<template lang="pug">
  b-field.select-label(:label="label")
    b-dropdown(v-model="innerData" @change="changeValue")
      b-field.has-addons(slot="trigger")
        .control
          ui-label(v-if="innerData" :label="innerData" button icon-right="menu-down")
          b-button(v-else icon-right="menu-down"): .has-text-grey {{ this.placeholder }}
        .control(v-if="withReset && innerData"): b-button.o-8(icon-left="close" @click.stop="changeValue(null)" :type="innerData.color")

      b-dropdown-item(v-for="status in labels.items" :key="status.id" :value="status")
        ui-label(:label="status")
</template>

<script>
import Label from '@/models/Label';

export default {
  name: 'select-label',

  props: {
    value: [String, Number],
    status: Object,
    label: String,
    withReset: Boolean,
    type: String,
    placeholder: {
      type: String,
      default: 'Тип',
    },
  },

  data: () => ({
    labels: Label.collection(),
    innerData: null,
  }),

  watch: {
    value(statusId) {
      this.updateInnerData(null, statusId);
    },
  },

  methods: {
    async loadState() {
      await this.labels.$fetch({
        filter: { type: this.type },
        // sort: "name",
      });
      this.$emit('onLoadState', this.labels);
    },

    changeValue(status) {
      this.$emit('input', status ? status.id : null);
      this.$emit('update:status', status);
    },

    updateInnerData(status, statusId) {
      if (status) {
        this.innerData = status;
      } else if (this.labels) {
        this.innerData = this.labels.find(statusId);
      }
    },
  },

  async created() {
    this.updateInnerData(this.status);
    await this.loadState();
    if (!this.status) {
      this.updateInnerData(null, this.value);
    }
  },
};
</script>
